// extracted by mini-css-extract-plugin
module.exports = {"introduction":"introduction_introduction__3z3sh","myName":"introduction_myName__14N-s","wordsCloud":"introduction_wordsCloud__1NSnv","wordText":"introduction_wordText__2hIw9"};